import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTours, fetchquotelist, fetchdestToursbyDest } from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
  checkboxalign: {
    alignSelf: "center",
    justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    //color: "red",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
  },
  button3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(4),
  },
  input: {
    color: "red",
  },
}));

export default function Kazakhstan() {
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const [quotelist, setquotelist] = useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [listtourData, setlisttourData] =useState([{
    tour_name: "",
    tour_description: "",
    tour_city: "",
    tour_destination: "",
    
    }]);

    useEffect(() => {
        loadtours()
        fetchQuotes()
      }, [])

    const loadtours = async () => {
        const data = await fetchdestToursbyDest("Kazakhstan");
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlisttourData(data.data)
    }
    const fetchQuotes=async()=>{
      const data2 = await fetchquotelist("Kazakhstan");
      setquotelist(data2.data);
    }
//console.log(listtourData);
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab label="How to Describe" {...a11yProps(0)} />
            <Tab label="Itineraries and Cost" {...a11yProps(1)} />
            <Tab label="Sightseeing Descriptions" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Typography variant="h6" className={classes.input}>
            About Kazakhstan:
          </Typography>
          <p>
          Kazakhstan, the largest country in Central Asia, is a land of contrasts where modern cities coexist with ancient traditions and vast natural landscapes. Known for its unique cultural heritage, breathtaking scenery, and growing reputation as a travel destination, Kazakhstan offers diverse experiences bound to enthrall travellers of all spheres of life
          </p>
          <Typography variant="h6" className={classes.input}>
            Main Attractions:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Top Places:</b> Almaty, Shymbulak, Astana
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Almaty City:</b> Panfilov Park, Zenkov Cathedral, Hun's ethnic village tour and the Green Bazaar.
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Almaty-Natural Wonders:</b> Charyn Canyon, Kolsai and Kaindy Lakes, Big Almaty Lake, Altai Mountains, Steppe Landscapes
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Shymbulak:</b> Medeu Skating Rink, Cable car and natural mountain view
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Astana:</b> Bayterek Tower, the Palace of Peace and Reconciliation, Boat trip on Ishim river and the Khan Shatyr Entertainment Center
              </ListItemText>
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.input}>
            Traveller type:
          </Typography>
          <p>Friends (P1), Family (P2), Groups (P3) </p>

          <Typography variant="h6" className={classes.input}>
            Duration:{" "}
          </Typography>
          <p>Min. 4 nights. Max. 7 nights</p>
          <Typography variant="h6" className={classes.input}>
            Visa process:{" "}
          </Typography>
          <p>
          Visa on arrival:
          Passport with 6 month Validity - from the date of return from KAzakhstan to passport expiry date, Return tickets, Proof of accommodation
          </p>
          <Typography variant="h6" className={classes.input}>
            How to reach:{" "}
          </Typography>
          <p>
          Direct flights from Delhi and easy connecting flights from multiple other cities
          Almaty International Airport (ALA): The busiest airport in Kazakhstan, located in the cultural hub, Almaty.
          Nursultan Nazarbayev International Airport (NQZ): Located in the capital city, Astana (formerly Nur-Sultan).
          </p>
          <Typography variant="h6" className={classes.input}>
            Distance between places:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Almaty airport - Almaty city centre : </b>  16 KM/ Approx 45 minutes
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Almaty – Shymbulak  : </b>  30 KM/ Approx 45 minutes
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Almaty – Astana  : </b>  1200 KM/ Approx 2 hours by flight
              </ListItemText>
            </ListItem>
          </List>
          <Typography variant="h6" className={classes.input}>
            Can be clubbed with:{" "}
          </Typography>
          <p>Azerbaijan</p>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography variant="h6" className={classes.input}>
            Flight cost: (per person return cost)
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>New Delhi:</b> 22-28k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Mumbai:</b> 25-30k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Bengaluru:</b> 28-33k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Hyderabad:</b> 28-32k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Chennai:</b> 30-35k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ahmedabad:</b> 28-32k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kolkata:</b> 28-32k
              </ListItemText>
            </ListItem>

          </List>
          <Typography variant="h6" className={classes.input}>
            Common Itineraries: (Cost and Quote Number)
          </Typography>
          <List>
          {quotelist?.map((quote) => {
                return (
                  <div>
                  <ListItem disablePadding>
                  <ListItemText>
                        <b><a href={"/quotedataentry/"+quote.quote_id} target="_blank" rel="noopener noreferrer">{quote.quote_id} - {quote.quote_identifier}</a></b>
                        </ListItemText>
                      </ListItem>
                  </div>
                );
              })}
          </List>
          <Typography variant="h6" className={classes.input}>
            Total Cost: (per person without flights and visa)
          </Typography>
          <List>
          <ListItem disablePadding>
          <ListItemText>
                <b>4N:</b> 35-40k
              </ListItemText>
          </ListItem>
          <ListItem disablePadding>
          <ListItemText>
                <b>5N:</b> 40-45k
              </ListItemText>
          </ListItem>
          <ListItem disablePadding>
          <ListItemText>
                <b>6N:</b> 45-50k
              </ListItemText>
          </ListItem>
          </List>
        </TabPanel>
        <TabPanel value={value} index={2}>
          {listtourData.length>1?(
            listtourData.map(tour =>
                <div>
                <p className={classes.input}>{tour.tour_name} -- Start time:({tour.start_time}) || End time:({tour.end_time})</p>
                    
                    {tour.tour_description}
                    <br></br>
                </div>
            )
          ):("")}
        </TabPanel>
      </Box>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
